import useSisenseScyLcmEventNoCourseDropdown from "./UseSisenseScyLcmEventNoCourseDropdown";

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SisenseScyLcmEventNoCourseDropdown = ({ label, name, value, error, message, onChange }) => {
  const { scyLcmEventNoCourseOptions } = useSisenseScyLcmEventNoCourseDropdown();

  return !scyLcmEventNoCourseOptions.options
    ? <span className={global.LoadingMsg}>{Constants.LOADING_MSG}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={scyLcmEventNoCourseOptions.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={!scyLcmEventNoCourseOptions.options}
      />
    );
};

export default SisenseScyLcmEventNoCourseDropdown;